import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Observations from "./Observations";
import Documents from "./Documents";
import "./panelDocument.css"
const initialState = {
  up: false,
  showFirst: true,
  text: "",
};
const PanelDocumentObservation = ({
  documents,
  observations,
  actionNewObservation,
  actionNewFiles,
  upload_more=true
}) => {
  const [panel, setpanel] = useState(initialState);
  const { up, showFirst, text } = panel;
  return (
    <div
      className={` ${
        up ? "fade-in-observation" : "fade-out-observation"
      } container-footer-observation-entry container-footer-observation-entry_test flex`}
    >
      <div className="w-100">
        <div className="flex container-tabs-entry">
          <div
            onClick={() => setpanel({ ...panel, showFirst: true })}
            className={` ${!showFirst && "tab-inactive-entry"} `}
          >
            Observaciones
          </div>
          <div
            onClick={() => setpanel({ ...panel, showFirst: false })}
            className={` ${showFirst && "tab-inactive-entry"} `}
          >
            Archivos
          </div>{" "}
        </div>

        <div
          onClick={() => setpanel({ ...panel, up: !up })}
          className="button-up-footer-obsevation-entry"
        >
          <FontAwesomeIcon
            className="margin-auto blue"
            icon={up ? faCaretDown : faCaretUp}
          />{" "}
        </div>
        <div className="content-tab-observation-entry_test content-tab-observation-entry w-100">
          {showFirst && up && (
            <Observations
              actionNewObservation={actionNewObservation}
              observations={observations}
            />
          )}
          {!showFirst && up && <Documents upload_more={upload_more} documents={documents} actionNewFiles={actionNewFiles} status_id={2} />}
        </div>
      </div>
    </div>
  );
};

export default PanelDocumentObservation;
